import { render, staticRenderFns } from "./SimulationRenderer.vue?vue&type=template&id=e53152c2&"
import script from "./SimulationRenderer.vue?vue&type=script&lang=js&"
export * from "./SimulationRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SimulationRenderer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports